import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { useIsDailyDiscountFieldMutation } from "queries";
import { merchantInfoActions } from "store";

import CardInfoSectionForm from "./cardInfoSectionForm";
import useUpdateUnderwritingCardInfoMutation from "../queries/useUpdateUnderwritingCardInfoMutation";

const CardInfoSection = ({ cardInfoValues }) => {
	const { id } = useParams();
	const dispatch = useDispatch();

	const { mutate: updateCardUWInfo, isLoading: loadingUpdateUWCardInfo } =
		useUpdateUnderwritingCardInfoMutation({
			onSuccess: () => {
				dispatch(merchantInfoActions.getMerchantInformation(id));
			},
		});

	const handleSubmit = values => {
		updateCardUWInfo(values);
	};

	const { mutate: submitApplicationIsDailyDiscountField } =
		useIsDailyDiscountFieldMutation();

	const handleIsDailyDiscountChange = useCallback(
		isDailyDiscount => {
			submitApplicationIsDailyDiscountField({
				id,
				value: isDailyDiscount,
			});
		},
		[id, submitApplicationIsDailyDiscountField],
	);

	return (
		<CardInfoSectionForm
			onSubmit={handleSubmit}
			initialValues={cardInfoValues}
			loadingUpdateCardInfo={loadingUpdateUWCardInfo}
			handleIsDailyDiscountChange={handleIsDailyDiscountChange}
		/>
	);
};

export default CardInfoSection;
